var Index_object_testimonials_slider = new Swiper(".Index_object_testimonials_slider", {
    slidesPerView: 4,
    spaceBetween: 16,
    direction: "horizontal",
    mousewheel: { forceToAxis: true },
    breakpoints: {
        0: {
            slidesPerView: 1.04462,
        },
        750: {
            slidesPerView: 2,
        },
        990: {
            slidesPerView: 3,
        },
        1281: {
            slidesPerView: 4,
        }
    }
});

document.addEventListener('click', function(e) {
  const soundButton = e.target.closest('.sound_icon');

  if (!soundButton) return;

  const currentSlide = soundButton.closest('.Index_object_testimonial_slide');
  const currentVideo = window.innerWidth <= 750
  ? currentSlide.querySelector('.Mobile_video_new')
  : currentSlide.querySelector('.Desktop_video_new');

  const isActive = soundButton.classList.contains('active');

  document.querySelectorAll('.Index_object_testimonial_slide').forEach(slide => {
   const video = window.innerWidth <= 750
  ? slide.querySelector('.Mobile_video_new')
  : slide.querySelector('.Desktop_video_new');
    const button = slide.querySelector('.sound_icon');

    if (video) video.muted = true;
    if (button) button.classList.remove('active');
  });

  if (!isActive) {
    currentVideo.muted = false;
    currentVideo.volume = 1;
    currentVideo.play();
    soundButton.classList.add('active');
  }
});